// js script to be put in very top of <head> tag in case js is rendered in php via client-mu-plugins
(function(gtmHelper, undefined) {
	/*
	 The following Data Layer entry should execute before the Google Tag Manager code is deployed, within the <head> of the website on every page of the website.

	 pageMeta.country Required: Contains the country in xx format of the current page the user is viewing. (For example "us" for the USA, "uk" for United Kingdom etc).
	 pageMeta.audience Required, where relevant: Identifies the visitor type based on the page they are viewing. The following mapping should be used with the value of this variable to the left of the below.
	 pa – Professional Advisors/Financial Advisors (advisor)
	 ii – Institutional Investors (institutional)
	 pi – Professional Investors/Individual Investors (retail)
	 pageMeta.region Required, where relevant: Identifies the region of the page currently being viewed. This should match the value on the left of the below:
	 emea - Europe, the Middle East and Africa
	 latam – Latin America
	 apac – Asia Pacific
	 na – North America
	 pageMeta.title Required: Should match the title of the current page.
	 pageMeta.name Required, where relevant: Should match the internal name of the page in question.
	 pageMeta.id Required: The ID of the current page, this should be a fixed value that matches the internal ID of the current page.
	 pageMeta.parentId Required, where relevant: Where a parent ID is available for the current page this field should be provided and include the parent ID.
	 pageMeta.fundName Required, where relevant: Should match the fund name of the fund currently being viewed when a user is on a product page of the website.
	 pageMeta.fundClass Required, where relevant: Should match the fund class of the fund currently being viewed when a user is on a product page of the website.
	 pageMeta.pageType Required: Should be a human-readable, fixed variable identifying the page type of the currently viewed page and is used to group similar pages together. For example: "home" "products" "campaign".
	 pageMeta.development Optional: When set to true GTM data will not be sent to production GTM container.
	 userMeta.userId Required, when logged in: Should match the internal ID for the current logged-in user.
	 */
	var country     = global_data_layer.country || undefined;
	var audience    = global_data_layer.audience || undefined;
	var region      = global_data_layer.region || undefined;
	var title       = global_data_layer.title || undefined;
	var name        = global_data_layer.name || undefined;
	var id          = global_data_layer.id || undefined;
	var parentId    = global_data_layer.parentId || undefined;
	var fundName    = global_data_layer.fundName || undefined;
	var fundClass   = global_data_layer.fundClass || undefined;
	var entityId    = global_data_layer.entityId || undefined;
	var pageType    = global_data_layer.pageType || undefined;
	var template    = global_data_layer.template || undefined;
	var category    = global_data_layer.category || undefined;
	var tags 		= global_data_layer.tags || undefined;
	var campaign    = global_data_layer.campaign || undefined;
	var author 		= global_data_layer.author || undefined;
	var date 		= global_data_layer.date || undefined;
	var language    = global_data_layer.language || undefined;
	var assetClass	= global_data_layer.assetClass || undefined;
	var relatedProd = global_data_layer.relatedProd || undefined;
	var development = global_data_layer.development || undefined;
	var userId      = global_data_layer.userId || undefined;
	var isInternal  = global_data_layer.isInternal || undefined;

	var scrambleId = getCookie( 'jhsubs' );
	if (scrambleId) {
		userId = scrambleId;
	}

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(
		{
			'pageMeta': {
				'country' 		 : country,
				'audience'		 : audience,
				'region'		 : region,
				'title'			 : title,
				'name'			 : name,
				'id'			 : id,
				'parentId'		 : parentId,
				'fundName'		 : fundName,
				'fundClass'		 : fundClass,
				'entityId'       : entityId,
				'pageType'		 : pageType,
				'template'		 : template,
				'category'		 : category,
				'tags'			 : tags,
				'campaign'		 : campaign,
				'author'  		 : author,
				'date' 			 : date,
				'language'		 : language,
				'assetClass'	 : assetClass,
				'relatedProduct' : relatedProd,
				'development'	 : development
			},
			'userMeta': {
				'userId' 		 : userId,
				'isInternal' 	 : isInternal
			}
		}
	);

	// console.log('global_data_layer');
	// console.log(global_data_layer);

	// Get cookie by name
	function getCookie(name) {
		var value = "; " + document.cookie;
		var parts = value.split( "; " + name + "=" );
		if (parts.length == 2) {
			return parts.pop().split( ";" ).shift();
		}
	};

})( window.gtmHelper = window.gtmHelper || {} );
